// GENERATED FILE - do not edit.
// Emitted by tools/generate-wire-schemas.mjs from
// Server/src/Shared/Server/Resources/openapi.json (the spec lockfile).
// Regenerate with: npm run generate:wire
//
// Base wire shape for the server "InspectSkillRawCall" component. The corresponding
// *.schema.ts is the facade that names it (and hosts any future refinement);
// see design/wiki/wire-schemas.md.
import { z } from "zod";

export const InspectSkillRawCallGenShape = z.strictObject({
  skillId: z.string(),
  issueIndex: z.number().optional(),
  attempt: z.number(),
  model: z.string(),
  temperature: z.number().optional(),
  systemPrompt: z.string(),
  systemPromptHash: z.string(),
  injectedVariables: z.array(z.string()),
  requestPrompt: z.string(),
  responseJson: z.string(),
});
